import t from 'react-translate'
import { css } from '@emotion/react';

import { seafoam } from 'athena/styles/colors';
import { danger, yellow } from 'styles/global_defaults/colors';
import { NpsDistribution } from 'redux/schemas/app/analytics';
import { extractTextFromHTML } from 'shared/utils';

import ScaleBar from './scale-bar';

type NpsScaleProps = {
  distribution: NpsDistribution;
  question: string;
};

const styles = css`
  min-height: 200px;
  flex: 1;
`;

const NpsScale = ({ distribution, question }: NpsScaleProps) => (
  <div css={styles} className='bg-white p-4'>
    <div className='text-large-regular bold mb-4'>
      {extractTextFromHTML(question)}
    </div>
    <ScaleBar
      scores={[
        { score: distribution.detractors.percentage, color: `${danger}33`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.NPS_SCORE_RATING.DETRACTORS(distribution.detractors.count) },
        { score: distribution.passives.percentage, color: `${yellow}33`, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.NPS_SCORE_RATING.PASSIVES(distribution.passives.count) },
        { score: distribution.promoters.percentage, color: seafoam, text: t.COURSE_ANALYTICS.NPS_CSAT_SURVEY.NPS_SCORE_RATING.PROMOTERS(distribution.promoters.count) },
      ]}
    />
  </div>
);

export default NpsScale;
